import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { Activity, ActivityModel } from 'src/app/models/activities';
import { UntypedFormGroup } from '@angular/forms';
import { WorkflowContextService } from 'src/app/services';
import { ReviewContractorRegistrationActivity } from 'src/app/models/activities/review-contractor-registration-activity';

@Component({
    selector: 'wm-review-contractor-registration-activity-view',
    templateUrl: './review-contractor-registration-activity-view.component.html',
    styleUrls: ['./review-contractor-registration-activity-view.component.css'],
    standalone: false
})
export class ReviewContractorRegistrationActivityViewComponent
  implements OnInit, ActivityView {
  activity: ReviewContractorRegistrationActivity;
  isPreview: boolean;
  isTestApplication: boolean;
  showSave?: EventEmitter<boolean>;
  showCancel?: EventEmitter<boolean>;
  showNext?: EventEmitter<boolean>;
  showPrevious?: EventEmitter<boolean>;
  goNext?: EventEmitter<boolean>;
  value$: EventEmitter<any>;
  initActivity: any;
  form: UntypedFormGroup;
  context: WorkflowContextService;
  nextOnSelect = false;
  viewTitle(): string {
    return 'Review Contractor Registration Activity';
  }
  applicationId?: string;

  constructor() {}

  ngOnInit() {}
}
